import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const TotalOnAgentHeaderCell = ({ _customRowProps: { integration } }: HeaderCellProps) => {
  return <div>Total On Agent</div>;
};

export default TotalOnAgentHeaderCell;
